module.exports = __webpack_public_path__ + "img/BOR_bus.0bcc4504.webp";